import { render, staticRenderFns } from "./OtherUserPermittedFunctionList.vue?vue&type=template&id=54c0421a&scoped=true&lang=pug"
import script from "./OtherUserPermittedFunctionList.vue?vue&type=script&lang=ts"
export * from "./OtherUserPermittedFunctionList.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserPermittedFunctionList.vue?vue&type=style&index=0&id=54c0421a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0421a",
  null
  
)

export default component.exports